import React from 'react'
import axios from 'axios'
import { FaTrash } from 'react-icons/fa'
import { toast } from 'react-toastify'

const ProductionHistoryTable = ({
    showItemEntries,
    productions,
    flatItems,
    summaryRows,
    loading,
    totals,
    setSelectedProduction,
    formatSalesValue,
    baseUrl,
    fetchProductions
}) => {

    const handleDelete = async (id) => {
        toast.info(
            ({ closeToast }) => (
                <div>
                    <p>Are you sure you want to delete this production?</p>

                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            marginTop: "10px",
                        }}
                    >
                        <button
                            onClick={async () => {
                                closeToast()

                                try {
                                    await axios.delete(
                                        `${baseUrl}/deletecentralkitchenproduction/${id}`
                                    )

                                    toast.success(
                                        "Production deleted successfully"
                                    )

                                    fetchProductions()
                                } catch (err) {
                                    console.error(err)

                                    toast.error(
                                        err?.response?.data?.error || err?.response?.data?.message ||
                                        "Failed to delete production"
                                    )
                                }
                            }}
                            className="px-3 py-1.5 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                        >
                            Confirm
                        </button>

                        <button
                            onClick={closeToast}
                            className="px-3 py-1.5 bg-gray-500 text-white rounded hover:bg-gray-600 text-sm"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ),
            {
                autoClose: false,
                closeOnClick: false,
            }
        )
    }

    return (
        <>
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
                <table className="w-full text-sm text-center">
                    <thead className="bg-gray-100 text-gray-700">
                        {!showItemEntries ? (
                            <tr>
                                <th className="px-3 py-2.5 font-semibold">
                                    SN
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Production Date
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Time
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Item Count
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Total Quantity
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Total Amount
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Action
                                </th>
                            </tr>
                        ) : (
                            <tr>
                                <th className="px-3 py-2.5 font-semibold">
                                    SN
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Production Date
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Time
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Item
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Quantity
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    UOM
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Rate
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Total
                                </th>
                            </tr>
                        )}
                    </thead>

                    <tbody>
                        {!showItemEntries ? (
                            productions.length > 0 ? (
                                productions.map((production, index) => (
                                    <tr
                                        key={production.id}
                                        onClick={() =>
                                            setSelectedProduction(production)
                                        }
                                        className="border-t border-gray-100 hover:bg-gray-50 transition cursor-pointer"
                                    >
                                        <td className="px-3 py-2.5">
                                            {index + 1}
                                        </td>

                                        <td className="px-2.5 py-2 whitespace-nowrap">
                                            {new Date(
                                                production.production_date
                                            ).toLocaleDateString()}
                                        </td>

                                        <td className="px-2.5 py-2 whitespace-nowrap">
                                            {production.time}
                                        </td>

                                        <td className="px-2.5 py-2">
                                            {production.item_count}
                                        </td>

                                        <td className="px-2.5 py-2">
                                            {parseFloat(
                                                production.total_quantity
                                            ).toFixed(2)}
                                        </td>

                                        <td className="px-2.5 py-2 font-semibold text-gray-800">
                                            {formatSalesValue(production.total)}
                                        </td>

                                        <td
                                            className="px-2.5 py-2"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <button
                                                onClick={() =>
                                                    handleDelete(production.id)
                                                }
                                                className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 disabled:opacity-40"
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={7}
                                        className="px-4 py-12 text-gray-500"
                                    >
                                        {loading
                                            ? "Loading productions..."
                                            : "No production records found"}
                                    </td>
                                </tr>
                            )
                        ) : flatItems.length > 0 ? (
                            flatItems.map((item, index) => (
                                <tr
                                    key={`${item.parent_id}-${item.id}`}
                                    className="border-t border-gray-100 hover:bg-gray-50 transition"
                                >
                                    <td className="px-3 py-2.5">
                                        {index + 1}
                                    </td>

                                    <td className="px-2.5 py-2 whitespace-nowrap">
                                        {new Date(
                                            item.production_date
                                        ).toLocaleDateString()}
                                    </td>

                                    <td className="px-2.5 py-2 whitespace-nowrap">
                                        {item.time || "-"}
                                    </td>

                                    <td className="px-2.5 py-2">
                                        {item.itemname}
                                    </td>

                                    <td className="px-2.5 py-2">
                                        {parseFloat(item.quantity).toFixed(2)}
                                    </td>

                                    <td className="px-2.5 py-2">
                                        {item.uom}
                                    </td>

                                    <td className="px-2.5 py-2">
                                        {formatSalesValue(item.rate)}
                                    </td>

                                    <td className="px-2.5 py-2 font-semibold text-gray-800">
                                        {formatSalesValue(item.total)}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="px-4 py-12 text-gray-500"
                                >
                                    No item entries found
                                </td>
                            </tr>
                        )}
                    </tbody>

                    <tfoot className="bg-gray-100 text-gray-800 font-semibold border-t border-gray-200">
                        {!showItemEntries ? (
                            <tr>
                                <td colSpan={3}>
                                </td>

                                <td
                                    className="px-3 py-2.5"
                                >
                                    Grand Total
                                </td>

                                <td className="px-3 py-2.5">
                                    {productions
                                        .reduce(
                                            (sum, item) =>
                                                sum +
                                                parseFloat(
                                                    item.total_quantity || 0
                                                ),
                                            0
                                        )
                                        .toFixed(2)}
                                </td>

                                <td className="px-3 py-2.5">
                                    {formatSalesValue(
                                        productions.reduce(
                                            (sum, item) =>
                                                sum +
                                                parseFloat(item.total || 0),
                                            0
                                        )
                                    )}
                                </td>

                                <td />
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan={3}>
                                </td>

                                <td
                                    className="px-3 py-2.5"
                                >
                                    Grand Total
                                </td>

                                <td className="px-3 py-2.5">
                                    {flatItems
                                        .reduce(
                                            (sum, item) =>
                                                sum +
                                                parseFloat(
                                                    item.quantity || 0
                                                ),
                                            0
                                        )
                                        .toFixed(2)}
                                </td>

                                <td />

                                <td />

                                <td className="px-3 py-2.5">
                                    {formatSalesValue(
                                        flatItems.reduce(
                                            (sum, item) =>
                                                sum +
                                                parseFloat(item.total || 0),
                                            0
                                        )
                                    )}
                                </td>
                            </tr>
                        )}
                    </tfoot>
                </table>
            </div>

            {showItemEntries && summaryRows.length > 0 && (
                <div className="mt-4 bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
                    <div className="px-4 py-2.5 bg-gray-100 border-b border-gray-200">
                        <div className="font-semibold text-gray-800 text-base">
                            Item Summary
                        </div>
                    </div>

                    <table className="w-full text-sm text-center">
                        <thead className="bg-gray-50 text-gray-700">
                            <tr>
                                <th className="px-3 py-2.5 font-semibold">
                                    Item
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    UOM
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Quantity
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Rate
                                </th>

                                <th className="px-3 py-2.5 font-semibold">
                                    Total
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {summaryRows.map((item, index) => (
                                <tr
                                    key={index}
                                    className="border-t border-gray-100 hover:bg-gray-50"
                                >
                                    <td className="px-3 py-2.5">
                                        {item.itemname}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        {item.uom}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        {item.quantity.toFixed(2)}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        {formatSalesValue(item.rate)}
                                    </td>

                                    <td className="px-3 py-2.5 font-semibold text-gray-800">
                                        {formatSalesValue(item.total)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    )
}

export default ProductionHistoryTable